export default "__VITE_ASSET__BTge_UpI__"